import React, { lazy, Suspense } from 'react';
import { useSearch } from '@/navigation.js';
import { Home } from '@/home.js';
import { AppContainer, LoadingMessage, ViewportWrapper } from '@/app.styled.js';
import { ConsentBanner } from '@/components/ui/consent-banner.js';

// The app, with Pixi and the canvas, is loaded only when a dataset is opened: the home page needs
// none of it, and shows the sooner for it
const App = lazy(() => import('@/app.js'));

const AppLoading = () => (
	<AppContainer>
		<ViewportWrapper>
			<LoadingMessage role="status">Loading…</LoadingMessage>
		</ViewportWrapper>
	</AppContainer>
);

/**
 * The home page, or the app when the address names a dataset: `/?set=one-piece`. Each shows the
 * consent banner: the app hides it while a slideshow plays.
 */
export const Root = () => {
	const search = useSearch();

	return new URLSearchParams(search).get('set') ? (
		<Suspense fallback={<AppLoading />}>
			<App />
		</Suspense>
	) : (
		<>
			<Home />
			<ConsentBanner />
		</>
	);
};
